import { render, staticRenderFns } from "./PrinterListLoadBody.vue?vue&type=template&id=2e24c904"
import script from "./PrinterListLoadBody.vue?vue&type=script&lang=ts"
export * from "./PrinterListLoadBody.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports